<template>
  <div>
    <vs-card
      ><ListSituacoesEvento
        :subjectPermission="subjectPermission"
      ></ListSituacoesEvento>
    </vs-card>
  </div>
</template>
<script>
import ListSituacoesEvento from '../situacoes-evento/situacoes-evento-data-list.vue';

export default {
  components: {
    ListSituacoesEvento,
  },
  data() {
    return {
      subjectPermission: 'Situação de Evento',
    };
  },
};
</script>
<style></style>
